<div id="exists_cards">
  <section id="basicdetails" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Basic Details</h2>
        <p>Please Save each and Every Section details.</p>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

            <div class="row">
              <div class="col-md-3 form-group">
                <!-- <input type="file" (change)="selectFile($event)" name="profimage" class="form-control" id="profimage" required> -->
              </div>
              <div class="col-md-3 form-group">
                <!-- <button class="btn btn-success" [disabled]="!selectedFiles" (click)="upload()">Upload</button> -->
              </div>
              <div class="col-md-3 form-group">
                <!-- <div *ngIf="currentFileUpload" class="progress">
                  <div class="progress-bar progress-bar-info progress-bar-striped" style="width: 100%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                       role="progressbar" attr.aria-valuenow="{{percentage}}"
                       aria-valuemin="0" aria-valuemax="100">
                    {{percentage}}%
                  </div>
                </div> -->
               </div>
               <div class="col-md-3 form-group">
                <img src={{profileurl}} alt="profile" class="img-prof"/>

              </div>

              <div class="col-md-4 form-group">
                <input type="text" name="fname" #bfname  value={{userfirstname}}  class="form-control" id="fname" placeholder="First Name" required>
              </div>
              <div class="col-md-4 form-group">
                <input type="text" name="mname" #bmname  value={{usermiddlename}} class="form-control" id="mname" placeholder="Middle Name" required>
              </div>
              <div class="col-md-4 form-group">
                <input type="text" name="lname" #blastname  value={{userlastname}} class="form-control" id="lname" placeholder="Last Name" required>
              </div>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #bpord name="pord" value={{posdesig}}  id="pord" placeholder="Position/ Designation" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #bcname name="cname" value={{companyname}}  id="cname" placeholder="Company Name" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #bnbus name="nbus" value={{natureofbusiness}} id="nbus" placeholder="Nature of Business" required>
            </div>
            <div class="form-group mt-3">
              <textarea class="form-control" #baddress name="address" value={{address}} rows="5" id="address" placeholder="Address" required></textarea>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #bphoneshow name="ph" value={{phoneshow}}  id="ph" placeholder="Phone Number" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #baph name="aph" value={{aphone}} id="aph" placeholder="Alternative Number" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #ll name="ll" value={{landline}} id="ll" placeholder="Landline Number" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #em name="em" value={{email}} id="em" placeholder="Email" required>
            </div>
            <div class="form-group mt-3">
              <input type="text" class="form-control" #wa name="wa" value={{whatsapp}} id="wa" placeholder="Whatsapp Number" required>
            </div>

            <div class="form-group mt-3">
              <input type="text" class="form-control" #ws name="ws" value={{website}} id="ws" placeholder="Website" required>
            </div>

            <div class="my-3">
              <div class="error-message"></div>
              <div id="bs-succ" class="display_none">Details Saved Successfully. Thank you!</div>
            </div>
            <div class="text-center">
              <!-- <button type="submit" (click)="basic_alt_det(bfname.value,bmname.value,blastname.value,bpord.value,bcname.value,bnbus.value,baddress.value,bphoneshow.value,baph.value,ll.value,em.value,wa.value,ws.value)">Save</button></div> -->
</div>
        </div>

      </div>

    </div>
  </section>
  <section id="social" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Social Media Integration</h2>
        <!-- <p>Please Save each and Every Section details.</p> -->

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

            <div class="row">
              <div class="col-md-6 form-group">
                <input type="text" #fblink name="fblink" value={{facebook}} class="form-control" id="fblink" placeholder="Facebook Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #insta name="insta" value={{instagram}} class="form-control" id="insta" placeholder="Instagram Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #mes name="mes" value={{messenger}} class="form-control" id="mes" placeholder="Messenger Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #twit name="twit" value={{twitter}} class="form-control" id="twit" placeholder="Twitter Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #yt name="yt" value={{youtube}} class="form-control" id="yt" placeholder="Youtube Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #liin name="liin" value={{linkedin}} class="form-control" id="liin" placeholder="Linkedin Link" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" #tele name="tele" value={{telegram}} class="form-control" id="tele" placeholder="Telegram Number" required>
              </div>
            <div class="my-3">
              <div class="error-message"></div>
              <div id="smi-succ" class="display_none">Details Saved Successfully. Thank you!</div>
            </div>
            <!-- <div class="text-center"><button type="submit" (click)="smi_det(fblink.value,insta.value, mes.value,twit.value,yt.value,liin.value,tele.value)">Save</button></div> -->
            </div>

        </div>

      </div>

    </div>
  </section>


  <section id="payment" class="contact">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Payments Integration</h2>
        <!-- <p>Please Save each and Every Section details.</p> -->

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0 php-email-form">

            <div class="row">
              <div class="col-md-3 form-group">
                <input type="text" name="gpayname" #gpaynme value={{gpayname}} class="form-control" id="gpayname" placeholder="Gpay User Name" required>
              </div>
              <div class="col-md-3 form-group">
                <input type="text" name="gpay" #gpy value={{gpay}} class="form-control" id="gpay" placeholder="UPI ID" required>
              </div>
              <div class="col-md-3 form-group">
                <input type="text" name="phpename" value={{phonepename}} #phpename class="form-control" id="phpename" placeholder="Phonepe User Name" required>
              </div>
              <div class="col-md-3 form-group">
                <input type="text" name="phpe" #phpe value={{phonepe}} class="form-control" id="phpe" placeholder="PhonePe UPI ID" required>
              </div>
        <p>Bank Account details.</p>

              <div class="col-md-6 form-group">
                <input type="text" name="bankname" #bnkname value={{bankname}} class="form-control" id="bankname" placeholder="Bank Name" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" name="accholname" #accholname value={{accountholdername}} class="form-control" id="accholname" placeholder="Account Holder Name" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" name="accnu" #acctnumber value={{accountnumber}} class="form-control" id="accnu" placeholder="Account Number" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" name="ifsc" #ifc value={{ifsc}} class="form-control" id="ifsc" placeholder="IFSC Code" required>
              </div>
              <div class="col-md-6 form-group">
                <input type="text" name="sorc" #sct value={{savingscurrent}} class="form-control" id="sorc" placeholder="Savings/ Current" required>
              </div>
            <div class="my-3">
              <div class="error-message"></div>
              <div  id="pay-succ" class="display_none">Details Saved Successfully. Thank you!</div>
            </div>
            <div class="text-center">
              <!-- <button type="submit" (click)="payment_det(gpaynme.value,gpy.value,phpename.value,phpe.value,bnkname.value,accholname.value,acctnumber.value,ifc.value,sct.value)">Save</button></div> -->
            </div>
</div>
        </div>

      </div>

    </div>
  </section>
  <section id="forms" class="contact">
    <div class="container" data-aos="">

      <div class="section-title">
        <h2>Enquiry Form</h2>
        <!-- <p>Please Save each and Every Section details.</p> -->

      </div>

      <div class="row mt-1 php-email-form">

        <div class="col-lg-12 mt-5 mt-lg-0">

          <!-- <form (ngSubmit)="enq_det(enqForm.value)" [formGroup]="enqForm" class="php-email-form"> -->
            <div class="row">
              <div class="col-md-12 form-group">
                <input type="text" name="enmail" value={{enemail}} class="form-control" id="enmail" placeholder="Email" required>
              </div>
            <div class="my-3">
              <div class="error-message"></div>
              <!-- <div id="enq-succ" class="display_none">Details Saved Successfully. Thank you!</div> -->
            </div>
            <!-- <div class="text-center"><button type="submit">Save</button></div> -->
            </div>
          <!-- </form> -->

        </div>

      </div>

    </div>
  </section>


  <section id="aboutus" class="contact">
    <div class="container" data-aos="">

      <div class="section-title">
        <h2>About Us</h2>

      </div>

      <div class="row mt-1 php-email-form">

        <div class="col-lg-12 mt-5 mt-lg-0">

          <!-- <form (ngSubmit)="aboutus_det(aboutForm.value)" [formGroup]="aboutForm" class=""> -->
            <div class="row">
              <div class="col-md-12 form-group">

                <div class="form-group mt-3">
                  <textarea class="form-control" value={{abtus}} name="aboutusfield"  rows="5" id="aboutusfield" placeholder="Details about you/ your business" required></textarea>
                </div>
              </div>
            </div>
            <div class="my-3">
              <!-- <div id="aboutus-succ" class="display_none">Details Saved Successfully. Thank you!</div> -->
            </div>
            <!-- <div class="text-center"><button type="submit"  [disabled]="!aboutForm.valid" >Save</button></div> -->
          <!-- </form> -->

        </div>

      </div>

    </div>
  </section>


  <section id="aboutus" class="contact">
    <div class="container" data-aos="">

      <div class="section-title">
        <h2>Products &amp; Services</h2>

      </div>

      <div class="row mt-1 php-email-form">

        <div class="col" *ngFor="let i of pands_urls">
          <div *ngIf="i">
            <div class=""><h2>{{i[0]}}</h2></div>
            <div class=""><h4>{{i[1]}}</h4></div>

                  <div class=""><img src={{i[2]}}  class="gal-img" alt="gallery"/></div>
                  <div class=""><a href={{i[2]}} target="_blank">click</a></div>

              </div>
        </div>

      </div>

    </div>
  </section>
  <section id="aboutus" class="contact">
    <div class="container" data-aos="">

      <div class="section-title">
        <h2>Gallery</h2>

      </div>

      <div class="row mt-1 php-email-form">

        <div class="col" *ngFor="let i of gallery_urls">
          <div *ngIf="i">

                  <div class=""><img src={{i[0]}}  class="gal-img" alt="gallery"/></div>
                  <div class=""><a href={{i[0]}} target="_blank">click</a></div>

              </div>
        </div>

      </div>

    </div>
  </section>
</div>
